import React from 'react';

import { observer } from 'mobx-react';

import classes from './PriceInfo.module.scss';
import { PriceInfoSection } from '../../../../components/checkout/PriceInfoSection/PriceInfoSection';
import { CurrentPrice } from '../../../../components/checkout/CurrentPrice/CurrentPrice';
import { challengeCheckoutStore } from '../../../../stores/challengeCheckoutStore';

const PriceInfo = observer(() => {
  const { challengeCheckoutInfo } = challengeCheckoutStore;

  if (!challengeCheckoutInfo) {
    return null;
  }

  const { challenge, promocode, checkoutDetails } = challengeCheckoutInfo;

  const isPromocodeUsedToCurrentPayment =
    Boolean(promocode) && checkoutDetails.discountAmount !== 0;

  return (
    <PriceInfoSection
      label="Pay for"
      name={<span className={classes.uppercase}>{challenge.challengeName}</span>}
    >
      <CurrentPrice
        price={challenge.priceFinal}
        hasDiscount={isPromocodeUsedToCurrentPayment}
        discountPercent={promocode?.discountPercent}
        oldPrice={challenge.price}
        suffix="/ one-time payment"
      />
    </PriceInfoSection>
  );
});

export { PriceInfo };
